<template>
  <div class="scene-list">
    <ul>
      <li v-for="(item, index) in sceneList[0].itemList">
          <router-link v-bind:to="'/'+ lan + '/scene/1/' + item.id">
            <img  v-bind:src="item.logoUrl"/>
            <p>{{ item.title}}</p>
          </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'SceneList',
    props: ['sceneList'],
    data() {
      return {
        lan: this.$route.params.language
      }
    }
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .scene-list{
    margin-top: 40px;
    font-family: PingFangSC-Regular;
    color: #000000;
    ul{
      display: flex;

      a{
        display: inline-block;
        width: 140px;
        text-align: center;
      }
    }
    li{
      list-style: none;
      width: 240px;
      img{
        width: 56px;
      }
      p{
        font-size: 16px;
        color: #737373;
        line-height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SceneList.vue?2740e057